import { INews } from '@collections/news/interfaces/news.interface';
import {Injectable} from '@angular/core';
import {Mutation, gql} from 'apollo-angular';

export interface ISoftDeleteNewsResponse {
  softDeleteNews: INews;
}

@Injectable()
export class SoftDeleteNewsGQL extends Mutation<ISoftDeleteNewsResponse> {
  document = gql`
    mutation softDeleteNews($companyId: ObjectId, $id: ObjectId!) {
      softDeleteNews(companyId: $companyId, id: $id) {
        _id
        deleted
      }
    }
  `;
}

export interface IRestoreDeletedNewsResponse {
  restoreDeletedNews: INews;
}

@Injectable()
export class RestoreDeletedNewsGQL extends Mutation<IRestoreDeletedNewsResponse> {
  document = gql`
    mutation restoreDeletedNews($companyId: ObjectId, $id: ObjectId!) {
      restoreDeletedNews(companyId: $companyId, id: $id) {
        _id
        deleted
      }
    }
  `;
}

export interface IHardDeleteNewsResponse {
  hardDeleteNews: INews;
}

@Injectable()
export class HardDeleteNewsGQL extends Mutation<IHardDeleteNewsResponse> {
  document = gql`
    mutation hardDeleteNews($id: ObjectId!) {
      hardDeleteNews(id: $id) {
        _id
      }
    }
  `;
}
